import script from "./TrendView.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendView.vue?vue&type=script&setup=true&lang=js"

import "./TrendView.vue?vue&type=style&index=0&id=45e238fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e238fe"]])

export default __exports__